import React, { useState, useEffect } from 'react';
import { BarChart2 } from 'lucide-react';
import api from '../api/client';

function rateColor(rate) {
  if (rate === null || rate === undefined) return '#6b7280';
  const n = parseFloat(rate);
  if (n >= 85) return '#16a34a';
  if (n >= 70) return '#c9a84c';
  return '#dc2626';
}

export default function AIQuality() {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/platform/ai-quality/tenants')
      .then(r => setTenants(r.data.tenants || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const active = tenants.filter(t => parseInt(t.total_queries || 0) > 0);
  const inactive = tenants.filter(t => parseInt(t.total_queries || 0) === 0);

  return (
    <div className="p-6">
      <div className="flex items-center gap-3 mb-6">
        <BarChart2 className="h-6 w-6 text-purple-400" />
        <h1 className="text-xl font-bold text-white">AI Quality — All Tenants</h1>
        <span className="text-xs text-gray-500 ml-auto">Last 30 days</span>
      </div>

      {loading ? (
        <p className="text-gray-500 text-sm">Loading...</p>
      ) : (
        <div className="bg-gray-800 border border-gray-700 rounded-xl overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="text-xs text-gray-500 border-b border-gray-700">
                <th className="text-left px-4 py-3 font-medium">Tenant</th>
                <th className="text-right px-4 py-3 font-medium">Queries (30d)</th>
                <th className="text-right px-4 py-3 font-medium">Confirm Rate</th>
                <th className="text-right px-4 py-3 font-medium">Active Users</th>
                <th className="text-right px-4 py-3 font-medium">Last Query</th>
              </tr>
            </thead>
            <tbody>
              {active.map(t => (
                <tr key={t.tenant_id} className="border-b border-gray-700/50 hover:bg-gray-750">
                  <td className="px-4 py-3 text-sm text-white font-medium">{t.tenant_name}</td>
                  <td className="px-4 py-3 text-sm text-gray-300 text-right">{t.total_queries}</td>
                  <td className="px-4 py-3 text-sm text-right font-semibold" style={{ color: rateColor(t.confirm_rate) }}>
                    {t.confirm_rate !== null ? `${t.confirm_rate}%` : '—'}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-300 text-right">{t.active_ai_users}</td>
                  <td className="px-4 py-3 text-xs text-gray-500 text-right">
                    {t.last_query_at ? new Date(t.last_query_at).toLocaleDateString() : '—'}
                  </td>
                </tr>
              ))}
              {inactive.length > 0 && (
                <>
                  <tr>
                    <td colSpan={5} className="px-4 py-2 text-[10px] text-gray-600 uppercase tracking-wide font-medium bg-gray-800/50">
                      Not using AI yet
                    </td>
                  </tr>
                  {inactive.map(t => (
                    <tr key={t.tenant_id} className="border-b border-gray-700/30">
                      <td className="px-4 py-2 text-sm text-gray-600">{t.tenant_name}</td>
                      <td className="px-4 py-2 text-sm text-gray-600 text-right">0</td>
                      <td className="px-4 py-2 text-sm text-gray-600 text-right">—</td>
                      <td className="px-4 py-2 text-sm text-gray-600 text-right">0</td>
                      <td className="px-4 py-2 text-sm text-gray-600 text-right">—</td>
                    </tr>
                  ))}
                </>
              )}
              {tenants.length === 0 && (
                <tr><td colSpan={5} className="px-4 py-8 text-center text-gray-500">No tenants found</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
